import { render } from "./Alert.vue?vue&type=template&id=d901f9d4&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=ts"
export * from "./Alert.vue?vue&type=script&lang=ts"

import "./Alert.vue?vue&type=style&index=0&id=d901f9d4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d901f9d4"

export default script